module.exports = __webpack_public_path__ + "media/images/reportimages/org_chart-6aff70fa14b6d6bd665305de3ed78549.png";